import React from 'react'

import { FileDetailIconProps } from './excel-drop-area.types'

const FileDetailIcon = (props: FileDetailIconProps) => {
  const { loading, playClickedFunction, result } = props
  
  let cssClass = 'fileStatic'

  if (loading) {
    cssClass = 'fileLoading'
  } else if (result?.isError) {
    cssClass = 'fileError'
  } else if (!result?.isError) {
    cssClass = 'fileSuccess'
  }

  return (
    <div className={`${cssClass}`} id='fileDetailIcon'>
      {loading && <span id='loadingIcon'></span>}
      {!loading && !result && (
        <span id='playIcon' onClick={playClickedFunction}>
          ▶
        </span>
      )}
      {result && result.isError && <span id='errorIcon'>✕</span>}
      {result && !result.isError && <span id='completeIcon'>✓</span>}
    </div>
  )
}

export default FileDetailIcon
